import { getProps } from "@/utils/helpers/columnsHelper";
import { TextField, CreateButton, TopToolbar, ListContextProvider, useListController } from "react-admin";
import { StatusChipField } from "@/components/common/fields/StatusChipField";
import { CreateInDialog } from "@/components/common/CreateInDialog";
import { PartnerCreate, ResourceName } from "@/types";
import { useState } from "react";
import List from "@/components/ui/react-admin/styledList/StyledList";
import { PageHeader } from "@/components/common/PageHeader";
import { getResourceIcon } from "@/utils/icons";
import { StyledDatagrid } from "@/components/ui/react-admin/StyledDatagrid";
import { useResourcePermissions } from "@/hooks/useResourcePermissions";

export const PartnerList = () => {
  const listContext = useListController({
    resource: ResourceName.PARTNERS,
    sort: { field: "partner_company_name", order: "ASC" },
  });

  const { isPending: loading } = listContext;

  const PartnersIcon = getResourceIcon(ResourceName.PARTNERS);

  return (
    <ListContextProvider value={listContext}>
      <PageHeader
        customTitle="Partners"
        hideSectionTitle
        rightContent={<PartnersListActions loading={loading} />}
        headerIcon={<PartnersIcon sx={{ fontSize: 28, color: "primary.main" }} />}
      />
      <List actions={false} loading={loading} sort={{ field: "partner_company_name", order: "ASC" }}>
        <StyledDatagrid rowClick="show" bulkActionButtons={false}>
          {/* Primary identifier */}
          <TextField {...getProps("aegle_id", ResourceName.PARTNERS)} />
          <StatusChipField {...getProps("status", ResourceName.PARTNERS)} />
          <TextField {...getProps("partner_company_name", ResourceName.PARTNERS)} />
          <TextField {...getProps("partner_code", ResourceName.PARTNERS)} />
          <TextField {...getProps("domain", ResourceName.PARTNERS)} />

          <TextField {...getProps("accel_product_name", ResourceName.PARTNERS)} />
        </StyledDatagrid>
      </List>
    </ListContextProvider>
  );
};

// Top toolbar actions
const PartnersListActions = ({ loading }: { loading?: boolean }) => {
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const { canCreate } = useResourcePermissions(ResourceName.PARTNERS);

  // Don't render anything if user can't create
  if (!canCreate) {
    return null;
  }

  return (
    <TopToolbar>
      <CreateButton
        onClick={(e) => {
          e.preventDefault();
          setOpenCreateDialog(true);
        }}
        disabled={loading}
      />
      <CreateInDialog<PartnerCreate>
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        resource={ResourceName.PARTNERS}
      />
    </TopToolbar>
  );
};
